import React from 'react';
import PropTypes from 'prop-types';
import { getCategoryIconURL } from 'utilities/expensesByCategories/categoriesUtilities';

const { AggregatorTableDetails } = require('../aggregatorTableDetails/aggregatorTableDetails');

const { FormattedText } = require('core/i18n').i18n;

const TRANSLATION_KEY_PREFIX = 'aggregatorCardBoxDetailsHeader';

class AggregatorCardDetails extends React.PureComponent {
  buildItem(item, isTinkAggregator) {
    const date = item.get('date');
    const category = item.getIn(['category', 'categoryCode']);
    const subCategory = item.getIn(['category', 'subcategoryCode']);
    const categoryIconUrl = getCategoryIconURL(`category_${category}`);
    const description = !isTinkAggregator ? item.get('description') : item.get('concept');
    const quantity = !isTinkAggregator ? item.get('quantity') : item.get('amount');

    return [
      {
        type: 'date',
        value: date,
      },
      {
        type: 'category',
        value: {
          category: category,
          subcategory: subCategory,
          icon: categoryIconUrl,
        },
      },
      {
        type: 'text',
        value: description,
      },
      {
        type: 'amount',
        value: quantity,
      },
    ];
  }

  buildTableValues = () => {
    const { details, isTinkAggregator } = this.props;

    const tableValues = details.get('movements', []) || [];

    return tableValues.map(item => this.buildItem(item, isTinkAggregator));
  };

  buildTableHeader = () => {
    return [
      <FormattedText
        key={`${TRANSLATION_KEY_PREFIX}-date`}
        value={`${TRANSLATION_KEY_PREFIX}-date`}
      />,
      <FormattedText
        key={`${TRANSLATION_KEY_PREFIX}-category`}
        value={`${TRANSLATION_KEY_PREFIX}-category`}
      />,
      <FormattedText
        key={`${TRANSLATION_KEY_PREFIX}-description`}
        value={`${TRANSLATION_KEY_PREFIX}-description`}
      />,
      <FormattedText
        key={`${TRANSLATION_KEY_PREFIX}-amount`}
        value={`${TRANSLATION_KEY_PREFIX}-amount`}
      />,
    ];
  };

  render() {
    const { details } = this.props;
    const header = this.buildTableHeader();
    const values = this.buildTableValues();
    const textButton = (
      <FormattedText value={'aggregatorCardDetails-showMoreDetails'} format="uppercase" />
    );
    const loading = details.get('loading'); // Check Tink side when transactions endpoint is ready ()

    return (
      <AggregatorTableDetails
        values={values}
        header={header}
        hasMore={true}
        toButton={`/myprofile/global/entities/cards/${this.props.productId}`}
        textButton={textButton}
        loading={loading}
      />
    );
  }
}

AggregatorCardDetails.propTypes = {
  details: PropTypes.object,
  productId: PropTypes.string,
  isTinkAggregator: PropTypes.bool,
};

export { AggregatorCardDetails };
